//api calls will be made here

import { toast } from 'react-toastify';
import base from '../apis';
import {
  GET_MARKETING_EXECUTIVES,
  GET_TOKEN,
  GET_USER_DETAILS,
  GET_USER_DETAILS_FROM_LOCAL,
  SIGNOUT,
  SWITCH_TO_SIGNIN,
  SWITCH_TO_SIGNUP,
  TOGGLE_AUTH_MODAL,
  TOGGLE_SIDEBAR,
  // TOKEN_ATTEMPT_ERROR,
  SET_MARKETING_EXECUTIVES,
  GET_MARKETERS_DETAILS,
  CLEAR_ERROR_MESSAGE,
} from './types';

//modal actions
export const toggleAuthModal = () => ({ type: TOGGLE_AUTH_MODAL });
export const switchToSignin = () => ({ type: SWITCH_TO_SIGNIN });
export const switchToSignup = () => ({ type: SWITCH_TO_SIGNUP });

//sidebar actions
export const toggleSidebar = () => ({ type: TOGGLE_SIDEBAR });

/** authentication actions */

export const GetToken =
  ({ email, password, navigate }) =>
  async (dispatch) => {
    dispatch({ type: 'START_LOADING' });
    base
      .post('/auth/jwt/create/', { email, password })
      .then((res) => {
        localStorage.setItem('atoken', res.data.access);
        localStorage.setItem('rtoken', res.data.refresh);
        dispatch({ type: GET_TOKEN, payload: res.data });
        dispatch(GetDetails(navigate));
      })
      .catch((err) => {
        dispatch({ type: 'STOP_LOADING' });
        toast.error(err.response?.data?.detail || 'An error occurred');
        // dispatch({
        //   type: TOKEN_ATTEMPT_ERROR,
        //   payload: err.response?.data?.detail || 'An error occurred',
        // });
      });
  };

export const clearErrorMessage = () => ({ type: CLEAR_ERROR_MESSAGE });

export const GetDetails = (navigate) => async (dispatch, getState) => {
  base
    .get('/auth/users/me', {
      headers: {
        Authorization: `JWT ${getState().auth.token.access}`,
      },
    })
    .then(({ data }) => {
      dispatch({ type: GET_USER_DETAILS, payload: data });
      // dispatch({ type: 'STOP_LOADING' });

      let route = '';
      switch (data.role) {
        case 'admin':
          route = '/operations-overview';
          dispatch({ type: 'STOP_LOADING' });

          navigate(route, { replace: true });

          break;
        case 'snr_marketer':
          route = '/dashboard';
          getMarketerDetails(data.role, dispatch, route, navigate);
          break;
        case 'marketer':
          route = '/marketing-exec-dashboard';
          getMarketerDetails(data.role, dispatch, route, navigate);
          break;

        default:
          route = '/';
          dispatch({ type: SIGNOUT });
          toast.error('You are not authorized to access this page');
          dispatch({ type: 'STOP_LOADING' });
          navigate(route, { replace: true });

          break;
      }
    })
    .catch(() => {
      toast.error('An error occurred');
      dispatch({ type: 'STOP_LOADING' });
    });
};

const getMarketerDetails = (role, dispatch, routeTo, navigate) => {
  let route = 'marketers';
  if (role === 'snr_marketer') route = 'snr_marketers';
  base
    .get(`/operations/${route}/me/`)
    .then(({ data }) => {
      dispatch({ type: GET_MARKETERS_DETAILS, payload: data });
      dispatch({ type: 'STOP_LOADING' });
      setTimeout(() => {
        navigate(routeTo, { replace: true });
      }, 200);
    })
    .catch((err) => {
      dispatch({ type: 'STOP_LOADING' });
      toast.error('Could not get marketers details');
    });
};
export const GetDetailsFromLocal = () => {
  const atoken = localStorage.getItem('atoken');
  const rtoken = localStorage.getItem('rtoken');
  const details = JSON.parse(localStorage.getItem('details'));

  if (atoken && rtoken && !!details) {
    return {
      type: GET_USER_DETAILS_FROM_LOCAL,
      payload: { ...details, rtoken, atoken },
    };
  } else
    return {
      type: 'noting',
    };
};

export const signout = () => {
  return {
    type: SIGNOUT,
  };
};

//! operations on Marketing Executive Actions

export const getMarketingExecs = () => async (dispatch, getState) => {
  base
    .get('/operations/marketers/')
    .then((res) => {
      dispatch({ type: GET_MARKETING_EXECUTIVES, payload: res.data });
    })
    .catch((err) => {});
};

export const enterMarketingExec = (data) => {
  return {
    type: SET_MARKETING_EXECUTIVES,
    payload: data,
  };
};
